import { KnownChainIds } from '@shapeshiftoss/types';
export const zrxSupportedChainIds = [
    KnownChainIds.EthereumMainnet,
    KnownChainIds.AvalancheMainnet,
    KnownChainIds.OptimismMainnet,
    KnownChainIds.BnbSmartChainMainnet,
    KnownChainIds.PolygonMainnet,
    KnownChainIds.ArbitrumMainnet,
    KnownChainIds.BaseMainnet,
];
